/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
} from './Bed';

/**
 * 
 * @export
 * @interface FindAllBeds200Response
 */
export interface FindAllBeds200Response {
    /**
     * 
     * @type {Array<Bed>}
     * @memberof FindAllBeds200Response
     */
    data?: Array<Bed>;
}

/**
 * Check if a given object implements the FindAllBeds200Response interface.
 */
export function instanceOfFindAllBeds200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllBeds200ResponseFromJSON(json: any): FindAllBeds200Response {
    return FindAllBeds200ResponseFromJSONTyped(json, false);
}

export function FindAllBeds200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllBeds200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(BedFromJSON)),
    };
}

export function FindAllBeds200ResponseToJSON(value?: FindAllBeds200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(BedToJSON)),
    };
}

